// src/components/AnimatedHeroBackground.js
import React, { useEffect, useMemo, useState } from "react";
import "./AnimatedHeroBackground.css";
import { NeuralNoise } from "./ui/neural-noise";

const AnimatedHeroBackground = ({ children }) => {
  const [theme, setTheme] = useState(
    document.documentElement.getAttribute("data-theme") || "dark"
  );

  useEffect(() => {
    const obs = new MutationObserver(() => {
      setTheme(document.documentElement.getAttribute("data-theme") || "dark");
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);

  const color = useMemo(() => {
    if (theme === "light") {
      // blue
      return [0.15, 0.39, 0.92]; // ~ #2563eb
    }
    // gold/orange
    return [1.0, 0.65, 0.12]; // ~ #ffa726
  }, [theme]);

  return (
    <div className="animated-hero-container">
      {/* ✅ fixed global background */}
      <div className="cb-bg-layer" aria-hidden="true">
        <NeuralNoise className="cb-neural-noise" color={color} opacity={0.78} speed={0.00035} />
        <div className="cb-vignette" />
      </div>

      {/* ✅ content above */}
      <div className="cb-content-layer">{children}</div>
    </div>
  );
};

export default AnimatedHeroBackground;
